import {TextLinkModel} from "./model/TextLinkModel";

export function TextLink(parameter: TextLinkModel) {

    return (
        <a href="#"
           className="font-medium text-indigo-600 hover:text-indigo-500">{parameter.text}</a>
    );
}